// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import ModulePreloader from "src/scripts/modules/modulePreloader";
import CustomAnimation from "src/scripts/modules/CustomAnimation";
import ModuleNavigation from "src/scripts/modules/moduleNavigation";
import ModuleForm from "src/scripts/modules/moduleForm";

const modulePreloader = new ModulePreloader();
const animations = new CustomAnimation();
const navigation = new ModuleNavigation();
const form = new ModuleForm();
const bodyPage = document.body.getAttribute('data-page');

jQuery(document).ready(function () {

  animations.init();
  navigation.init();
  form.init();

  $('.button_faq').click(function(e){
    e.preventDefault();

    $(this).next(".faq_content").slideToggle();
    $(this).closest("li").siblings().find('.faq_content').slideUp();

    if( $(this).hasClass('open') ) {
      $('.button_faq').removeClass("open");
      $(this).removeClass('open')
    }
    else {
      $('.button_faq').removeClass("open");
      $(this).addClass('open')
    }
  });

  if(bodyPage === 'newsroom') {

    const video = document.getElementById("blogVideo03");
    const modal = document.getElementById("blogModal03");

    modal.addEventListener("hidden.bs.modal", function () {
      if (video) {
        video.pause(); // Pausiere das Video
        video.currentTime = 0; // Setze den Videofortschritt zurück, falls notwendig
      }
    });
  }




  /*
  const openModalButton = document.querySelector(".btn_click");
  const modal = document.getElementById("modal");
  const closeModalButton = document.getElementById("close-modal");

  openModalButton.addEventListener("click", function (event) {
    event.preventDefault();
    modal.classList.remove("hidden");
  });

  closeModalButton.addEventListener("click", function () {
    modal.classList.add("hidden");
  });

  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.classList.add("hidden");
    }
  });
*/


  setTimeout(function () {
    modulePreloader.hidePreloaderLogo();
  }, 500);

  setTimeout(function () {
    modulePreloader.hidePreloader();
  }, 1000);
});
